<div class="outer-container lea-outer-container">
  <p-accordion class="custom-accordion" [activeIndex]="0">

    <p-accordionTab [header]="'Data Templates'">
      <div class="headerSection">
        Download the required templates to prepare data for submission.
      </div>

            <div class="lea-data-table-container">

         <dx-data-grid #dataGrid [dataSource]="portalTemplateNames" [showBorders]="true"
                        [rowAlternationEnabled]="true" [columnAutoWidth]="true" [wordWrapEnabled]="true"
                        [allowColumnResizing]="true" [columnResizingMode]="'widget'"
                        (onContentReady)="setActionColumnWidth($event)" (onEditorPrepared)="onEditorPrepared($event)"  [wordWrapEnabled]="false">

                        <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
                        <dxo-header-filter [visible]="true"></dxo-header-filter>
                         <dxo-paging [pageSize]="currentPageSize"></dxo-paging>
                        <dxo-pager [visible]="true" [allowedPageSizes]="[10, 25, 50, 100]" [displayMode]="displayMode"
                            [showPageSizeSelector]="true" [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
                        <dxo-sorting mode="multiple"></dxo-sorting>
                          <dxo-scrolling  mode="standard" showScrollbar="always" useNative="true"></dxo-scrolling>
                        <ng-container *ngFor="let column of templateLeagridConfig; let i = index">
                            <ng-container *ngIf="column.hide !== true">
                                <ng-container *ngIf="column.link; else noLink">
                                    <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                        [allowFiltering]="column.filter" cellTemplate="cellTemplate"></dxi-column>
                                </ng-container>
                                <ng-template #noLink>
                                    <ng-container *ngIf="column.icon; else noIcon">
                                        <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                            [allowFiltering]="column.filter" cellTemplate="iconTemplate"></dxi-column>
                                    </ng-container>
                                </ng-template>
                                <!-- <ng-template #noIcon>
                                    <ng-container *ngIf="column.dateFormat; else noDate">
                                        <dxi-column
                                            *ngIf="column.dateFormat === 'date' || column.dateFormat === 'datetime'"
                                            [dataField]="column.columnDef" [caption]="column.header"
                                            [allowFiltering]="column.filter" [dataType]="'date'" format="MM/dd/yyyy">
                                        </dxi-column>
                                    </ng-container>
                                </ng-template>
                                <ng-template #noDate>
                                    <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                        [allowFiltering]="column.filter">
                                    </dxi-column>
                                </ng-template> -->
                                <ng-template #noIcon>
                                    <ng-container *ngIf="column.dateFormat; else noBadge">
                                        <dxi-column
                                            *ngIf="column.dateFormat === 'date' || column.dateFormat === 'datetime'"
                                            [dataField]="column.columnDef" [caption]="column.header"
                                            [allowFiltering]="column.filter" [dataType]="'date'" format="MM/dd/yyyy">
                                        </dxi-column>
                                    </ng-container>
                                    <ng-template #noBadge>
                                        <ng-container *ngIf="column.badge; else noDate">
                                            <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                [allowFiltering]="column.filter" cellTemplate="badgeTemplate">
                                            </dxi-column>
                                        </ng-container>
                                        <ng-template #noDate>
                                            <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                [allowFiltering]="column.filter">
                                            </dxi-column>
                                        </ng-template>
                                    </ng-template>
                                </ng-template>
                            </ng-container>
                        </ng-container>
                        <dxi-column *ngIf="isVisible || isActionVisible" caption="Actions" [width]="actionColumnWidth"
                            [allowSorting]="false" cellTemplate="actionsTemplate"></dxi-column>

                        <div *dxTemplate="let data of 'actionsTemplate'" class="leadatactioncontainer datatemplateleadatactioncontainer">
                            <button class="action-icon-button"
                                [ngStyle]="{ 'display': (isShowEdit === true) ? 'inline-block' : 'none' }"
                                pTooltip="Download" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="onDownloadTemplateWithoutData(data)">
                                <span class="sr-only">Download</span>
                                <span class="material-symbols-outlined">download</span>
                            </button>
                        </div>
                        <div *dxTemplate="let d of 'cellTemplate'">
                            <span href="javascript:void(0)" *ngIf="d.value && d.value !== 'null'" class="link-data"
                                (click)="getRouter(d)">{{
                                d.value !== 'null' ? d.value : ''
                                }}</span>
                        </div>
                        <ng-container>
                            <div *dxTemplate="let d of 'cellTemplate'">
                                <span *ngIf="d.value && d.value !== 'null'" #contentWrapper
                                    [innerHTML]="d.value | safeHtml">{{
                                    d.value !== 'null' ? d.value : ''
                                    }}</span>
                            </div>
                        </ng-container>
                        <div *dxTemplate="let d of 'badgeTemplate'">
                            <span class="status-badge" [ngClass]="{
                        'badge-active': d.value?.toLowerCase() === 'active',
                        'badge-inactive': d.value?.toLowerCase() === 'inactive',
                    }">
                                <span class="dot"></span>
                                {{ d.value }}
                            </span>
                        </div>
                        <div *dxTemplate="let d of 'iconTemplate'">
                            <em class="fa fa-book"></em>
                        </div>
                    </dx-data-grid>
                    </div>

    </p-accordionTab>

  </p-accordion>

  <p-accordion class="custom-accordion" [activeIndex]="0">

    <p-accordionTab [header]="'Reference Documents'">
      <div class="headerSection">
        Download supporting documents and additional instructions related to data reporting requirements.
      </div>

      <div class="lea-data-table-container">

        <div class="lea-ref-doc-grid-wrap">
          <app-data-grid #refDocGrid [config]="refDocDataGridConfig" id="ref_doc_grid_datagrid"
                         [actionsTemplateRef]="refDocActionsTemplate"></app-data-grid>
        </div>

        <ng-template #refDocActionsTemplate let-row>
          <div class="leadatactioncontainer">
            <button class="action-icon-button"
                    pTooltip="Download" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                    (click)="onDownloadReferenceDocument({data: row})">
              <span class="sr-only">Download</span>
              <span class="material-symbols-outlined">download</span>
            </button>
          </div>
        </ng-template>

      </div>

    </p-accordionTab>

  </p-accordion>

  <p-accordion class="custom-accordion" [activeIndex]="0">

    <p-accordionTab [header]="'Data Submissions'">

     <div class="headerSection">
        Upload completed data templates for submission and review. Review error counts to identify submissions requiring correction.
    </div>
    
     <div class="d-flex justify-content-end my-3">
        <button type="button" class="btn btn-primary grid rounded upload-btn ml-2" aria-label="Upload"
                      pRipple icon="pi pi-plus"
                      tooltipPosition="bottom" (click)="showUploadModal(uploadModel)"><img class="mr-2 width-20"
                        src="../../../../assets/images/neveda-images/upload.svg" alt="" srcset="">Upload</button>
    </div>

            <div class="lea-data-table-container">

       <dx-data-grid #dataGrid [dataSource]="portalSubmissionList" [showBorders]="true"
                        [rowAlternationEnabled]="true" [columnAutoWidth]="true" [wordWrapEnabled]="true"
                        [allowColumnResizing]="true" [columnResizingMode]="'widget'"
                        (onContentReady)="setActionColumnWidth($event)" (onEditorPrepared)="onEditorPrepared($event)"  [wordWrapEnabled]="false">

                        <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
                        <dxo-header-filter [visible]="true"></dxo-header-filter>
                        <dxo-paging [pageSize]="currentPageSize"></dxo-paging>
                        <dxo-pager [visible]="true" [allowedPageSizes]="[10, 25, 50, 100]" [displayMode]="displayMode"
                            [showPageSizeSelector]="true" [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
                        <dxo-sorting mode="multiple"></dxo-sorting>
                        <dxo-scrolling  mode="standard" showScrollbar="always" useNative="true"></dxo-scrolling>

                        <ng-container *ngFor="let column of submissiontemplateLeagridConfig; let i = index">
                            <ng-container *ngIf="column.hide !== true">
                                <ng-container *ngIf="column.link; else noLink">
                                    <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                        [allowFiltering]="column.filter" cellTemplate="cellTemplate"></dxi-column>
                                </ng-container>
                                <ng-template #noLink>
                                    <ng-container *ngIf="column.icon; else noIcon">
                                        <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                            [allowFiltering]="column.filter" cellTemplate="iconTemplate"></dxi-column>
                                    </ng-container>
                                </ng-template>
                                <!-- <ng-template #noIcon>
                                    <ng-container *ngIf="column.dateFormat; else noDate">
                                        <dxi-column
                                            *ngIf="column.dateFormat === 'date' || column.dateFormat === 'datetime'"
                                            [dataField]="column.columnDef" [caption]="column.header"
                                            [allowFiltering]="column.filter" [dataType]="'date'" format="MM/dd/yyyy">
                                        </dxi-column>
                                    </ng-container>
                                </ng-template>
                                <ng-template #noDate>
                                    <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                        [allowFiltering]="column.filter">
                                    </dxi-column>
                                </ng-template> -->
                                                                <ng-template #noIcon>
                                    <ng-container *ngIf="column.dateFormat; else noBadge">
                                        <dxi-column
                                            *ngIf="column.dateFormat === 'date' || column.dateFormat === 'datetime'"
                                            [dataField]="column.columnDef" [caption]="column.header"
                                            [allowFiltering]="column.filter" [dataType]="'date'" format="MM/dd/yyyy">
                                        </dxi-column>
                                    </ng-container>
                                    <ng-template #noBadge>
                                        <ng-container *ngIf="column.badge; else noDate">
                                            <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                [allowFiltering]="column.filter" cellTemplate="badgeTemplate">
                                            </dxi-column>
                                        </ng-container>
                                        <ng-template #noDate>
                                            <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                [allowFiltering]="column.filter">
                                            </dxi-column>
                                        </ng-template>
                                    </ng-template>
                                </ng-template>
                            </ng-container>
                        </ng-container>
                        <dxi-column caption="Status" [allowSorting]="false" [allowFiltering]="false" cellTemplate="submissionStatusTemplate"></dxi-column>
                        <dxi-column *ngIf="isVisible || isActionVisible" caption="Actions" [width]="actionColumnWidth"
                            [allowSorting]="false" cellTemplate="actionsTemplate"></dxi-column>

                        <div *dxTemplate="let d of 'submissionStatusTemplate'">
                            <span class="status-badge" [ngClass]="{
                                'badge-archived': d.row?.data?.status === 'Archived',
                                'badge-accepted': d.row?.data?.status !== 'Archived' && !(d.row?.data?.errorcount > 0),
                                'badge-correction': d.row?.data?.status !== 'Archived' && d.row?.data?.errorcount > 0
                            }">
                                <span class="dot"></span>
                                <ng-container *ngIf="d.row?.data?.status === 'Archived'">Archived</ng-container>
                                <ng-container *ngIf="d.row?.data?.status !== 'Archived'">
                                    {{ d.row?.data?.errorcount > 0 ? 'Correction Required' : 'Accepted' }}
                                </ng-container>
                            </span>
                        </div>
                        <div *dxTemplate="let data of 'actionsTemplate'" class="leadatactioncontainer"   [ngClass]="{
                        'leadatactioncontainer-single-btn': !(data?.data?.errorcount > 0), 'leadatactioncontainer-multi-btn': data?.data?.errorcount > 0}">
                            <button class="action-icon-button"
                                [ngStyle]="{ 'display': (isShowEdit === true) ? 'inline-block' : 'none' }"
                                pTooltip="Download" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="onDownloadTemplate(data)">
                                <!-- <span class="sr-only">Download</span> -->
                                <span class="material-symbols-outlined">download</span>
                            </button>
                            <button *ngIf="data?.data?.errorcount > 0" class="action-icon-button"
                                [ngStyle]="{ 'display': (isShowEdit === true) ? 'inline-block' : 'none' }"
                                pTooltip="Error Report Download" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="onDownloadErrorTemplate(data)">
                                <span class="material-symbols-outlined">error</span>
                                <!-- <span class="material-symbols-outlined">download</span> -->

                            </button>
                             <!-- <button class="fa fa-download action-icon-button"
                                [ngStyle]="{ 'display': (isShowEdit === true) ? 'inline-block' : 'none' }"
                                pTooltip="Download" tooltipPosition="bottom" (click)="onDownloadErrorTemplate(data)">
                                <span class="sr-only">Error Report</span>
                            </button> -->

                        </div>
                        <div *dxTemplate="let d of 'cellTemplate'">
                            <span href="javascript:void(0)" *ngIf="d.value && d.value !== 'null'" class="link-data"
                                (click)="getRouter(d)">{{
                                d.value !== 'null' ? d.value : ''
                                }}</span>
                        </div>
                        <ng-container>
                            <div *dxTemplate="let d of 'cellTemplate'">
                                <span *ngIf="d.value && d.value !== 'null'" #contentWrapper
                                    [innerHTML]="d.value | safeHtml">{{
                                    d.value !== 'null' ? d.value : ''
                                    }}</span>
                            </div>
                        </ng-container>
                        <div *dxTemplate="let d of 'iconTemplate'">
                            <em class="fa fa-book"></em>
                        </div>
                                                <div *dxTemplate="let d of 'badgeTemplate'">
                            <span class="status-badge" [ngClass]="{
                        'badge-active': d.value?.toLowerCase() === 'active',
                        'badge-inactive': d.value?.toLowerCase() === 'inactive',
                    }">
                                <span class="dot"></span>
                                {{ d.value }}
                            </span>
                        </div>
                    </dx-data-grid>

            </div>
    </p-accordionTab>

  </p-accordion>

</div>





<!-- <div class="outer-container">

  <app-accordian [title]="dataTemplateSection.title" >
    <div class="headerSection">
            Download the required templates to prepare data for submission.
    </div>
    <div class="header-row p-2 d-flex align-items-center justify-content-end mb-0" 
         id="data_template_div_headeractions">
      <app-grid-actions
        id="data_template_grid_actions"
        [actions]="dataTemplateSection.gridActions"
        [showColumnChooser]="dataTemplateSection.showColumnChooser"
        [allColumns]="dataTemplateSection.allColumns"
        [visibleColumns]="dataTemplateSection.visibleColumns"
        (exportClick)="onDataTemplateExport()"
        (columnChooserToggle)="onDataTemplateColumnChooserToggle()"
        (columnToggle)="onDataTemplateColumnToggle($event)"
        (columnChooserClose)="onDataTemplateColumnChooserClose()">
      </app-grid-actions>
    </div>
   <app-data-grid  #dataTemplateGrid   [config]="dataTemplateSection.dataGridConfig" id="data_template_grid_datagrid">
      <ng-template #actionsTemplate let-data let-rowIndex="index">
        <div class="action-buttons-container d-flex gap_action"
            [id]="'data_template_grid_div_actionbuttons_' + index">
            <span class="action-span-wrapper view-wrapper" >
                <button type="button" (click)="$event.stopPropagation(); downloadTemplate(data)" matTooltipClass="custom-tooltip"
                    class="action-icon-button" matTooltip="Download" matTooltipPosition="above">
                    <img src="assets/images/neveda-images/download.svg" alt="" width="20" height="20" aria-hidden="true"/>
                </button>
            </span>
        </div>
    </ng-template>
    </app-data-grid>
  </app-accordian>


  <app-accordian [title]="dataSubmissionSection.title" >
    <div class="headerSection">
        Upload completed data templates for submission and review. Review error counts to identify submissions requiring correction.
    </div>
    <div class="header-row p-2 d-flex align-items-center justify-content-end mb-0" 
         id="data_submission_div_headeractions">
         <div class="d-flex align-items-center">      
      <app-grid-actions
        id="data_submission_grid_actions"
        [actions]="dataSubmissionSection.gridActions"
        [showColumnChooser]="dataSubmissionSection.showColumnChooser"
        [allColumns]="dataSubmissionSection.allColumns"
        [visibleColumns]="dataSubmissionSection.visibleColumns"
        (exportClick)="onDataSubmissionExport()"
        (columnChooserToggle)="onDataSubmissionColumnChooserToggle()"
        (columnToggle)="onDataSubmissionColumnToggle($event)"
        (columnChooserClose)="onDataSubmissionColumnChooserClose()">
      </app-grid-actions>
      <div>
        <button type="button" class="btn btn-primary grid rounded upload-btn ml-2" aria-label="Upload"
                      pRipple icon="pi pi-plus"
                      tooltipPosition="bottom" (click)="showUploadModal(uploadModel)"><img class="mr-2 width-20"
                        src="../../../../assets/images/neveda-images/upload.svg" alt="" srcset="">Upload</button>
      </div>
         </div>
    </div>
    <app-data-grid  #dataTemplateGrid   [config]="dataSubmissionSection.dataGridConfig" id="data_submission_grid_datagrid">
      <ng-template #actionsTemplate let-data let-rowIndex="index">
        <div class="action-buttons-container d-flex gap_action"
            [id]="'data_submission_grid_div_actionbuttons_' + index">
            <span class="action-span-wrapper view-wrapper" >
                <button type="button" (click)="$event.stopPropagation(); downloadTemplate(data)" matTooltipClass="custom-tooltip"
                     matTooltip="Download" matTooltipPosition="above" class="action-icon-button" >
                    <img src="assets/images/neveda-images/download.svg" alt="" width="20" height="20" aria-hidden="true"/>
                </button>
            </span>
        </div>
    </ng-template>
    </app-data-grid>
  </app-accordian>


 
</div> -->

<ng-template #uploadModel let-modal>
  <form #uploadForm="ngForm" novalidate>
    <div class="upload-form-popup">
      <div class="form-modal-header p-4 d-flex justify-content-between">
        <h4 class="modal-title">Upload Files</h4>
        <button type="button" class="close" aria-label="Close" (click)="closeUploadPopup()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="form-modal-body pl-4 pr-4 pt-4 pb-2">
        <div class="mb-3">
          <!-- <label class="col-form-label mb-2">Select File <span class="text-danger">*</span></label> -->
          <div class="upload-drop-area" (click)="fileInputRef.click()" (dragover)="$event.preventDefault()"
            (dragleave)="$event.preventDefault()" (drop)="onDropFile($event)">
            <div class="upload-drop-content">
              <span class="p-button-icon p-button-icon-left pi pi-upload upload"></span>
              <span class="dragdropconatiner">Drag &amp; drop or <span class="choose-file-link">choose a file</span> to upload</span>
            </div>
            <input type="file" #fileInputRef class="file-input-hidden" (click)="clearFileInput($event)"
              (change)="handleFileUpload($event)" accept=".csv,.xlsx,.xls" />
          </div>
          <div class="no-file-uploaded mt-20" [ngClass]="!uploadData.file?'no-file-uploaded border-0':''"><i
              *ngIf="!uploadData.file" class="pi pi-file"></i>
            <span *ngIf="uploadData.file" class="text-left border-0">{{ uploadData.file.name }}</span>
            <span *ngIf="!uploadData.file">No file
              uploaded</span>
          </div>
          <div *ngIf="uploadError" class="text-danger small mt-2">{{ uploadError }}</div>
        </div>
        <div class="mb-3 filedetails">
          <p class="filesformat">
            Supported formats: Excel
          </p>
          <p class="filesformat">
            Maximum size: 15 MB.
          </p>
        </div>
        <div class="row mb-3">
            <div class="col-md-6">
                <label class="col-form-label mb-2 custom-template-label">Template <span class="text-danger">*</span></label>
                <!-- <select class="form-control selecTemplate" [(ngModel)]="uploadData.template" name="template"
                    [ngClass]="{'placeholder': !uploadData.template}"  (change)="onTemplateBlur($event)">
                    <option class="templateOptions" [ngValue]="null" disabled hidden>Select Template</option>
                    <option class="templateOptions" *ngFor="let template of portalTemplateNames" 
                     [ngValue]="template">{{ template.template_name }}
                    </option>
                  </select> -->
                <p-dropdown [options]="portalTemplateNames" [(ngModel)]="uploadData.template" name="template"
                    optionLabel="template_name" placeholder="Select Template" [showClear]="false"
                    styleClass="custom-template-dropdown" [ngClass]="{'placeholder': !uploadData.template}"
                    (onChange)="onTemplateBlur($event)" [filter]="true" filterBy="template_name">
                </p-dropdown>
                <div *ngIf="templateError" class="text-danger small mt-2">{{ templateError }}</div>
            </div>
            <div class="col-md-6">
                <label class="col-form-label mb-2 custom-template-label">
                    School Year <span class="text-danger">*</span>
                </label>
                <p-dropdown
                    [options]="schoolYears"
                    [(ngModel)]="uploadData.schoolYear"
                    name="schoolYear"
                    optionLabel="value"
                    optionValue="key"
                    placeholder="Select School Year"
                    [showClear]="false"
                    styleClass="custom-template-dropdown"
                    [ngClass]="{'placeholder': !uploadData.schoolYear}"
                    [filter]="true" filterBy="value"  [disabled]="true">
                </p-dropdown>
                <div *ngIf="schoolYearError" class="text-danger small mt-2">{{ schoolYearError }}</div>
            </div>
        </div>

            <div *ngIf="showText" class="validation-banner">
                <div class="spinner"></div>
                <div class="validation-text">
                    <p class="validation-title">Submission is being validated</p>
                    <p class="validation-sub">This may take a few moments. Any issues found will be reflected in the Error Count.
                    </p>
                </div>
            </div>
            <div *ngIf="showErrorBanner && !showText" class="status-banner error-banner">
                <div class="error-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="8" x2="12" y2="12"></line>
                        <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                </div>
                <div class="validation-text">
                    <p class="banner-title">Submission Failed</p>
                    <p class="banner-sub">{{ errorBannerMessage }}</p>
                </div>
                <!-- <button class="banner-close" (click)="showErrorBanner = false">&times;</button> -->
            </div>

      </div>
      <div class="form-modal-footer p-3 d-flex">
        <button type="button" class="btn-cancel btn  btn-md  px-3 py-1" (click)="closeUploadPopup()">Cancel</button>
        <button lang="en" class="btn btn-primary btn-md rounded ms-2" type="button" name="data[submit]"
           [disabled]="!uploadData.file || !uploadData.template?.template_id || !uploadData.schoolYear || saveEnable" (click)="onSave()" ref="button">Save
        
        </button>
      </div>
    </div>

  </form>
</ng-template>